import {ErrorData} from 'packages/errors/errors';
import {post} from 'packages/rest/api';

export async function RequstSignInMagicLinkAPI(identifier: string, origin?: string): Promise<ErrorData | null> {
    const res = await post({url: 'session/magic', body: {identifier, origin}});

    return res[1];
}
